export default "__VITE_ASSET__DMtdWFoH__"